// src/hooks/library/useGetLoansQuery.ts
import { useQuery } from "react-query";
import { getLoans } from "../../services/library/loan";
import { key_loans } from "../../utils/constants";
import { PagedRequestType } from "../../types/PagedResults";

export const useGetLoansQuery = (data: PagedRequestType, options: any = null) =>
    useQuery(
        [key_loans, JSON.stringify(data)],
        () => getLoans(data),
        options ? { ...options } : {}
    );
